import { render, staticRenderFns } from "./moreEATG.vue?vue&type=template&id=22f770ce&lang=pug&"
import script from "./moreEATG.vue?vue&type=script&lang=js&"
export * from "./moreEATG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports